import React from 'react';
import { Block, HiddenField } from '@guryou/html-components';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { dealTokens, SystemFieldControl } from 'components/shared';

const useStyles = makeStyles({
  counterContainer: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${dealTokens.color.border}`,
    borderRadius: dealTokens.radius.md,
    padding: dealTokens.space[2],
    width: 140,
    justifyContent: 'space-between',
    backgroundColor: dealTokens.color.canvas,
  },
  number: {
    minWidth: 30,
    textAlign: 'center',
    fontWeight: dealTokens.font.weightMedium,
  },
});

const StaffCount = ({ name, count, setCount, title, allowNone = false }) => {
  const classes = useStyles();

  const increment = () => {
    if (!Number(count)) {
      setCount(1);
    } else {
      setCount(count + 1);
    }
  };

  const decrement = () => {
    if (count === 1 && allowNone) {
      setCount('none');
    } else if (!Number(count)) {
      setCount(1);
    } else {
      setCount(Math.max(1, count - 1));
    }
  };

  return (
    <Block margin={0} marginTop={4} padding={0}>
      <SystemFieldControl label={title} name={name}>
        <Box className={classes.counterContainer}>
          <IconButton onClick={decrement} disabled={count === 'none'}>
            <RemoveIcon />
          </IconButton>
          <Typography className={classes.number}>{count}</Typography>
          <IconButton onClick={increment}>
            <AddIcon />
          </IconButton>
        </Box>
      </SystemFieldControl>
      <HiddenField name={name} value={allowNone ? (count === 'none' ? '' : count) : count} />
    </Block>
  );
};

export default StaffCount;
